import { createFileRoute } from "@tanstack/react-router"
import { QRs } from "modules/campaigns/components/Sections/triggers/qr"
import { PaginationSearchSchema } from "modules/shared/hooks/usePagination"
import { SearchQuerySchema } from "modules/shared/hooks/useSearchQuery"
import { Crumb } from "modules/shared/lib/breadcrumbs"
import { QRsSortSchema } from "schema"
import { z } from "zod"

// eslint-disable-next-line react-refresh/only-export-components
export const SearchSchema = PaginationSearchSchema.merge(SearchQuerySchema).merge(
  QRsSortSchema.shape.sortBy.unwrap(),
)

export const Route = createFileRoute("/_base/_auth/settings/channels/qr")({
  component: QRs,
  validateSearch: (search: Partial<z.infer<typeof SearchSchema>>) => {
    return SearchSchema.parse(search)
  },
  loader: ({ route: { fullPath } }) => {
    return new Crumb({
      fullPath,
      title: (t) => t("campaigns.templates.qr.title"),
    })
  },
})
